/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Audit_Logs_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "User actions, system events, and every AI interaction, so you have a complete record. Retention depends on your plan, and logs can be exported as CSV or JSON." |
*
* @param {Uno_Edu_Intro_Audit_Logs_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_audit_logs_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Audit_Logs_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Audit_Logs_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzeraktionen, Systemereignisse und jede KI-Interaktion, sodass Sie einen vollständigen Datensatz haben. Die Aufbewahrung hängt von Ihrem Tarif ab, und Protokolle können als CSV oder JSON exportiert werden.")
	return /** @type {LocalizedString} */ ("User actions, system events, and every AI interaction, so you have a complete record. Retention depends on your plan, and logs can be exported as CSV or JSON.")
});